<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Manual Sync</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <div class="row">
            <div class="col-md-12" style="word-spacing:-2px">
                Employee Codes/IDs must be separated by commas. For example: 103378,104935,111705,149476
            </div>
        </div>
        <table class="table table-bordered custom-table mt-3 mb-0">
            <tr>
                <td class="setting-subtitle py-1" colspan="2">
                    <h3 class="setting-subtitle">Sync</h3>
                </td>
            </tr>
            <tr>
                <td>
                    <form @submit.prevent="triggerManualSync">
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                Employee Codes/IDs
                            </div>
                            <div class="col-md-9">
                                <textarea rows="3" v-model="syncEmployeeCodes" class="form-control" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right mt-2">
                                <button type="submit" class="btn btn-primary">Process</button>
                            </div>
                        </div>
                    </form>
                </td>
            </tr>
        </table>

        <table class="table table-bordered custom-table mt-4 mb-0">
            <tr>
                <td class="setting-subtitle py-1" colspan="2">
                    <h3 class="setting-subtitle">Sync Roster</h3>
                </td>
            </tr>
            <tr>
                <td>
                    <form @submit.prevent="triggerManualSyncRoster">
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                Employee Codes/IDs
                            </div>
                            <div class="col-md-9">
                                <textarea rows="3" v-model="syncRosterEmployeeCodes" class="form-control" required />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right mt-2">
                                <button type="submit" class="btn btn-primary">Process</button>
                            </div>
                        </div>
                    </form>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import API from "../../http-common.js";
export default {
    data() {
        return {
            syncEmployeeCodes: "",
            syncRosterEmployeeCodes: "",
        };
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },
    methods: {
        triggerManualSync() {
            let param = {
                Token: this.token,
                EmployeeCodes: this.syncEmployeeCodes
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to process the sync?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.triggerManualSync(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, { icon: response.data.success ? "success" : "error" });
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            console.log(error);
                        });
                }
            });
        },
        triggerManualSyncRoster() {
            let param = {
                Token: this.token,
                EmployeeCodes: this.syncRosterEmployeeCodes
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to process the sync roster?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.triggerManualSyncRoster(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, { icon: response.data.success ? "success" : "error" });
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            console.log(error);
                        });
                }
            });
        }
    },
    created() {
        if (this.role != "admin") this.$router.replace({ name: "home" });
    },
}
</script>

<style scoped>
table {
    width: 800px;
}

h3.setting-subtitle {
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/System/ManualSync.vue